export const CONTACTS = {
  phone: import.meta.env.VITE_CONTACTS_PHONE,
  email: import.meta.env.VITE_CONTACTS_EMAIL
}

export const CART_FEATURES = [
  {
    key: 1,
    icon: '/icons/cart/features/1.svg',
  },
  {
    key: 2,
    icon: '/icons/cart/features/2.svg',
  },
  {
    key: 3,
    icon: '/icons/cart/features/3.svg',
  },
]
